<template>
    <div class="animated fadeIn">
      <vue-loading :active="isLoading" loader="bars" :is-full-page="false"></vue-loading>
        <b-form inline>
          <b-form-group>
            <h3>Export</h3>
          </b-form-group>
          <b-form-group
            label="Type"
            description="Membership Type">
            <b-select :options="membershipType" v-model="exportForm.type"></b-select>
          </b-form-group>
          <b-form-group
            label="Status"
            description="Membership Status">
            <b-select :options="membershipStatus" v-model="exportForm.status"></b-select>
          </b-form-group>
          <b-form-group
            label="Fields"
            description="Fields"
          >
            <b-form-select
              :multiple="true"
              :options="[
                {value: 'id', text: 'Id'},
                {value: 'status', text: 'Status'},
                {value: 'type', text: 'Type'},
                {value: 'person', text: 'Person'},
                {value: 'personEmail', text: 'Person Email'},
                {value: 'paymentSource', text: 'Payment Source '},
              ]"
              :select-size="2"
              v-model="exportForm.fields"
            ></b-form-select>
          </b-form-group>
          <div slot="footer" class="form-group">
            <b-button type="button" size="sm" variant="primary" v-on:click="exportMembers" ><i class="fa fa-search" ></i> Export</b-button>
          </div>
          <b-form-group
            v-if="exportData.length > 0"
          >
            Total: <strong>{{ totalMembers }}</strong>
          </b-form-group>
          <b-form-group>
            <download-csv
              class="btn btn-info"
              v-if="exportData.length > 0"
              :data="exportData"
            >
              Download Members
            </download-csv>
          </b-form-group>
        </b-form>
    </div>
</template>
<script>
    import {RepositoryFactory} from "../../services/repositories/RepositoryFactory";
    import {Membership} from "../../models/Membership"
    import VueLoading from "vue-loading-overlay/src/js/Component";
    import {parseEnum} from "../../shared/utils";

    const ExportRepo = RepositoryFactory.get('export')

    export default {
      name: 'membership-export-form',
      components: {
        VueLoading
      },
      data() {
          return {
            membershipStatus: parseEnum(Membership.STATUS),
            membershipType:  parseEnum(Membership.TYPES),
            exportForm: {
              status: '',
              type: '',
              fields: [],
            },
            totalMembers: 0,
            exportData: [],
            isLoading: false,
          }
        },
        methods: {
            exportMembers() {
                this.isLoading = true,
                this.exportData = [],
                ExportRepo
                    .exportMembers(this.exportForm)
                    .then(
                        response => (
                            this.isLoading = false,
                            this.totalMembers = response.data.data.memberships.length,
                            this.exportData = response.data.data.memberships
                        )
                    )
            },
        }
    }
</script>
<style>
  .form-group {
    margin-right: 10px;
  }
</style>
